module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M32 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V2zm-9.932 10.902l-5.316 8.724c-.302.498-.796.498-1.1 0l-5.318-8.724c-.304-.498-.072-.902.52-.902h10.694c.592 0 .822.404.52.902z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/down-square-1.js
// module id = 1114
// module chunks = 14